<script>
	import Leader from '$lib/icons/leadership-svgrepo-com.svelte';
	import Water from '$lib/icons/water-drop-svgrepo-com.svelte';
</script>

<div class="content-div">
	<span class="chip static-courser bg-[#D17208] mt-4 text-white"><b>Case Study 1</b></span>
	<div class="flex">
		<h1 class="content-heading">Rural water supply (Upper Zambezi / Barotse floodplain)</h1>
		<Water />
	</div>

	<div class="flex pt-2 pb-4">
		<Leader />
		<div class="pl-4 text-lg">
			<a class="anchor" href="/team#imasiku_nyambe">Kawawa Banda</a>
		</div>
	</div>

	<blockquote class="content-blockquote">
		One of the key uncertainties surrounding the impacts of a changing climate in Africa is the
		effect that it will have on the sustainability of rural water supplies (Christensen et al,
		2007). Of Africa’s population of 900 million, roughly 60% live in rural areas of whom most
		(~80%) rely on groundwater-based community or household supplies for domestic and other water
		needs (Funder et al, 2015). Nevertheless, ground water is often ignored in development debates –
		including those on water supply and management. A number of factors make groundwater a
		preferable option for rural water supply schemes: groundwater can be easily developed closer to
		homesteads; is generally of an acceptable quality with low contamination risk; is relatively
		cheap to develop, is more reliable and drought-proof compared to surface water and is less
		susceptible to seasonal and perennial fluctuations. The occurrence of groundwater depends
		primarily on the geology, geomorphology and recent and historic rainfall. The
		inter-relationships between these factors create complex patterns of water availability,
		quality, reliability, ease of access and sustainability. Climate change will superimpose itself
		by modifying rainfall and evaporation patterns, raising questions about how such changes may
		affect groundwater availability and, ultimately, tipping points in rural water supplies for both
		humans and livestocks. This case study will focus on the Upper Zambezi because of deteriorating
		surface water quality (Nyambe et al, 2018), high groundwater salinity and poor inhabitants who
		depend on groundwater (Banda et al, 2019).
	</blockquote>
</div>
